import * as server from '../entries/pages/(app)/(main)/support/_page.server.ts.js';

export const index = 9;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/(main)/support/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/(app)/(main)/support/+page.server.ts";
export const imports = ["_app/immutable/nodes/9.BS_rJfFk.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/CvggxNKg.js","_app/immutable/chunks/DXxkZ4MO.js","_app/immutable/chunks/aVAL63j_.js","_app/immutable/chunks/CxviFN-L.js","_app/immutable/chunks/R6oqabqE.js","_app/immutable/chunks/Cc9MKd4K.js","_app/immutable/chunks/ZDu7Cnc7.js","_app/immutable/chunks/CHKvhKB-.js","_app/immutable/chunks/DJzU1nGG.js","_app/immutable/chunks/a9k1QIbI.js","_app/immutable/chunks/Dnhbl7cy.js"];
export const stylesheets = ["_app/immutable/assets/Animate.8Bt8slzn.css"];
export const fonts = [];
